import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from "./assets/svg/undraw_well-done_kqud.svg";
import { ReactComponent as Logox } from "./assets/svg/undraw_destination_fkst.svg";
import { ReactComponent as Logoc } from "./assets/svg/undraw_newspaper_cqtq.svg";
import { ReactComponent as Logov } from "./assets/svg/undraw_login_wqkt.svg";
import { CaretLeft, Circle } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { toast } from "sonner";

const Login = () => {
  const routerPush = useNavigate();
  const [slide, setSlide] = useState(0);
  const [isLogin, SetIsLogin] = useState(true);

  const [cookies, setCookie] = useCookies(["token"]);
  const isUserLogin = cookies.token !== undefined && cookies.token !== null && cookies.token !== "undefined";


  // Redirect jika user sudah login
  useEffect(() => {
    if (isUserLogin) {
      routerPush("/register");
    }
  }, [isUserLogin, routerPush]);

  // Menampilkan UI berdasarkan status loading atau error

    
  const displayData = [
    {
      header: "Selamat Datang",
      footer:
        "Absensi teratur, tercatat, terekap secara sistematis dan terjadwal",
      img: <Logo width={250} height={220} />,
    },
    {
      header: "Absen di Lokasi",
      footer: "Tracking Dengan Akurat",
      img: <Logox width={250} height={220} />,
    },
    {
      header: "Mudah dan Tercatat",
      footer:
        "Hanya dengan menekan tombol ceklis atau scan barcode semua sudah tercatat",
      img: <Logoc width={250} height={220} />,
    },
  ];
  const handleClick = () => {
    if (slide < 3) {
      setSlide(slide + 1);
    }
    return;
  };

  const handleSignIn = () => {
    SetIsLogin(true);
  };
  const handleSignUp = () => {
    // routerPush('/register')
    setSlide(4);
  };

  const handlePrev = () => {
    setSlide(3);
  };

  const handleAccessLogin = () => {
    routerPush("/");
  };

  const handleCheckUser = async (userEmail, cred) => {
    try {
      const checkUsers = await axios.get(
        `${process.env.REACT_APP_SERVER}/api/login/${userEmail}`
      );

      if(checkUsers.data.payload.datas.status === 0)
        return toast.error("Maaf, kamu bukan lagi karyawan disini")
      else if(checkUsers.data.payload.datas.name === ''){
        toast.success('Login is Success')
        // Mengatur cookie
        setCookie("token", String(cred), { path: "/" });
        routerPush("/register");
      }else{
        toast.success('Login is Success')

        setCookie("token", String(cred), { path: "/" });
        routerPush("/");
      }
    } catch (error) {
      console.error("Error: " + error);
      if (error.status === 404) {
        toast.error("Kamu bukan karyawan sini");
      }  else {
        toast.error("Ada error di aplikasi nih, tolong hubungin developer kamu nih");
      }
    }
  };

  return (
    <div
      onClick={handleClick}
      className=" bg-slate-50 min-h-svh w-full relative flex justify-center items-center"
    >
      {slide < 3 ? (
        <>
          <p className="text-3xl font-bold absolute pt-10 top-0">
            {displayData[slide].header}
          </p>
          <div className="flex flex-col items-center pb-10">
            {displayData[slide].img}
          </div>
          <div className="bottom-0 pb-10 absolute text-slate-600">
            <p className="text-lg font-normal pb-8 px-6 text-center">
              {displayData[slide].footer}
            </p>
            <div className="flex gap-1.5  justify-center">
              <Circle weight="fill" size={10} />
              <Circle weight={slide >= 1 ? "fill" : "regular"} size={10} />
              <Circle weight={slide === 2 ? "fill" : "regular"} size={10} />
            </div>
          </div>
        </>
      ) : slide === 3 ? (
        <>
          <p className="text-3xl font-bold absolute pt-10 top-0">Sign Up</p>
          <div className="flex flex-col items-center pb-10">
            <Logov width={250} height={220} />
          </div>
          <div className=" w-6/12  absolute h-32 bottom-0 mb-16 rounded-xl flex justify-center ">
            <div className="flex justify-center flex-col gap-2 w-full items-center">
              {/* {isLogin ? (
                <>
                  <input
                    className="w-full border-2 border-slate-500 rounded-lg  p-2"
                    type="email"
                    placeholder="masukan email..."
                  />
                  <input
                    className="w-full border-2 border-slate-500 rounded-lg  p-2"
                    type="password"
                    placeholder="masukan password..."
                  />
                </>
              ) : (
                <div
                  onClick={handleSignIn}
                  className="bg-slate-500 cursor-pointer w-full rounded-lg h-8 text-center font-semibold flex items-center justify-center text-white"
                >
                  Sign In
                </div>
              )} */}
              {isLogin ? (
                <>
                  {/* <div className="flex gap-2 w-full">
                    <div
                      onClick={handleSignUp}
                      className="bg-slate-400 cursor-pointer  w-3/4 rounded-lg h-8 text-center font-semibold flex items-center justify-center text-white"
                    >
                      Sign Up
                    </div>
                    <div
                      onClick={handleAccessLogin}
                      className="bg-green-600 cursor-pointer  w-full rounded-lg h-8 text-center font-semibold flex items-center justify-center text-white"
                    >
                      Sign In
                    </div>
                  </div> */}
                  <GoogleLogin
                    onSuccess={(credentialResponse) => {
                      toast.info("Process Login. Wait a minute, Please")
                      const userEmail = jwtDecode(
                        credentialResponse.credential
                      ).email;
                      handleCheckUser(userEmail, credentialResponse.credential);
                    }}
                    onError={() => {
                      toast.info("Process Login. Wait a minute, Please")
                      toast.error("Login Failed");
                      console.log("Login Failed");
                    }}
                  />
                  {/* <div onClick={loginG} className="bg-blue-600 cursor-pointer  w-full rounded-lg  text-center font-semibold flex items-center justify-center text-white h-12">Sign in With Google</div> */}
                </>
              ) : (
                <div
                  onClick={handleSignUp}
                  className="bg-slate-400 cursor-pointer  w-full rounded-lg h-8 text-center font-semibold flex items-center justify-center text-white"
                >
                  Sign Up
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        slide === 4 && (
          <>
            <div
              className="absolute cursor-pointer z-10 mt-6 left-0 px-4 top-0 text-black "
              onClick={handlePrev}
            >
              <CaretLeft size={24} weight="bold" />
            </div>

            {/* <Register handlePrev={handlePrev} /> */}
          </>
        )
      )}
    </div>
  );
};

export default Login;
